// extracted by mini-css-extract-plugin
export default {"asianMore":"styles_asianMore__ItB6N","asianMore__bottom":"styles_asianMore__bottom__N-bL2","asianMore__active":"styles_asianMore__active__it6Fz"};